/**
 * API-Client für die selbstständige Account-Löschung + den Datenauszug
 * (Phase HH, Kapitel 20.6, Entscheidung #43).
 */

import { apiFetch } from './api';

export const accountDeletionApi = {
  requestDeletion: (token: string) =>
    apiFetch<{ ok: true; deletionScheduledFor: string }>('/api/me/request-deletion', {
      method: 'POST',
      token,
    }),

  /**
   * Lädt den Datenauszug als JSON-Objekt. Kein eigener `Blob`-Pfad nötig —
   * `apiFetch` parst die Antwort ohnehin als JSON; der Download-Trigger
   * passiert im aufrufenden Code (siehe AccountDeletionCard.tsx).
   */
  dataExport: (token: string) => apiFetch<Record<string, unknown>>('/api/me/data-export', { token }),
};
